import { render, staticRenderFns } from "./MainGlobeSceneDefault.vue?vue&type=template&id=a495a5be&scoped=true&"
import script from "./MainGlobeSceneDefault.vue?vue&type=script&lang=js&"
export * from "./MainGlobeSceneDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a495a5be",
  null
  
)

export default component.exports